import React, { useEffect } from "react";
import News from "../NewsFid/News";
import Banner from "./Banner/Banner";
import { useLocation } from "react-router-dom";
import RecordingVideos from "../RecordingVideos/RecordingVideos";
import NewNewsFront from "../NewsFid/New/NewNewsFront";
import SlidingVideos from "../SlidingVideos/SlidingVideos";

const Home = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
      <div>
        <Banner />
      </div>
      <div>
      <NewNewsFront />
      </div>
      <div>
      <SlidingVideos />
      </div>
    </div>
  );
};

export default Home;
